// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.root :global .dropdown-container {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid darkgray;
  border-radius: 1.5rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
`, "",{"version":3,"sources":["webpack://./src/app/Controls/Core/MultiSelectComboBox.less"],"names":[],"mappings":"AACA;EAIM,cAAA;EACA,WAAA;EACA,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,4BAAA;EACA,0BAAA;EACA,qBAAA;EACA,wEAAA;AAHN","sourcesContent":["\n.root {\n\n  :global {\n    .dropdown-container {\n      display: block;\n      width: 100%;\n      height: calc(1.5em + 0.75rem + 2px);\n      font-size: 1rem;\n      font-weight: 400;\n      line-height: 1.5;\n      color: #495057;\n      background-color: #fff;\n      background-clip: padding-box;\n      border: 1px solid darkgray;\n      border-radius: 1.5rem;\n      transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n    }\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
